(() => {
  const CHAT_HASH = "#qeydo-open-chat";

  const openShopifyChat = () => {
    const chatApi = window.ShopifyChat || window.Shopify?.chat;
    if (chatApi && typeof chatApi.open === "function") {
      chatApi.open();
      return true;
    }

    const chatHost = document.querySelector(
      "#ShopifyChat, #shopify-chat, shopify-chat, [data-shopify-chat]"
    );
    if (!chatHost) return false;

    const shadowButton = chatHost.shadowRoot?.querySelector(
      'button, [role="button"]'
    );
    if (shadowButton) shadowButton.click();
    else if (typeof chatHost.click === "function") chatHost.click();
    if (typeof chatHost.focus === "function") chatHost.focus();
    return true;
  };

  const handleChatLink = (event) => {
    const link = event.target.closest(`a[href="${CHAT_HASH}"]`);
    if (!link) return;
    event.preventDefault();

    if (openShopifyChat()) return;

    let attempts = 0;
    const waitForInbox = window.setInterval(() => {
      attempts += 1;
      if (openShopifyChat()) {
        window.clearInterval(waitForInbox);
      } else if (attempts >= 12) {
        window.clearInterval(waitForInbox);
        window.location.assign("/pages/contact");
      }
    }, 250);
  };

  document.addEventListener("click", handleChatLink);

  if (window.location.hash === CHAT_HASH) {
    window.addEventListener("load", () => {
      window.setTimeout(() => {
        if (!openShopifyChat()) window.location.replace("/pages/contact");
      }, 500);
    });
  }
})();
